import { render, staticRenderFns } from "./TextTooltip.vue?vue&type=template&id=5db3e2c4&scoped=true&"
import script from "./TextTooltip.vue?vue&type=script&lang=js&"
export * from "./TextTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TextTooltip.vue?vue&type=style&index=0&id=5db3e2c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db3e2c4",
  null
  
)

export default component.exports